import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface ActiveAuctionIdState {
    /** Currently active AMS Auction Id to display */
    id: string
}

export const useActiveAuctionIdStore = create<ActiveAuctionIdState>()(
    devtools(
        persist(
            (set, get) => ({
                id: '',
            }),
            { name: 'edge-active-auction-id' },
        ),
        { name: 'ActiveAuctionIdStore' },
    ),
)

/** Cached state only.
 *
 * This value is synced through a few ways:
 *
 * * `useSetFirstAsActiveAuction` will set an active auction on login if none exists. This will reset to the first auction on logout/login.
 * * `changeAuction` mutation when using the Auction dropdown.
 * * `validateAuthorizedAuctions` during any `useAllOrganizations`/`getAllOrganizations` query which will set the first auction if none exists,
 *    or reset to the first auction if the active auction is no longer authorized.
 *
 * If issues arise, consider `useActiveOrganization().orgId` and raise */
export const useActiveAuctionId = () => useActiveAuctionIdStore((state) => state.id)
export const getActiveAuctionId = () => useActiveAuctionIdStore.getState().id
export const setActiveAuctionId = (id: string) => useActiveAuctionIdStore.setState({ id })
